import React from 'react'

import BaseMakeDropdown from 'components/BaseMakeDropdown'
import { FieldKit } from 'containers/FormBuilder'
import { FormikValues } from 'formik'
import AssetSubtype from 'state/enums/AssetSubtype'
import AssetType from 'state/enums/AssetType'

interface MarineMakeDropdownProps {
    assetSubtype: AssetSubtype
    condition: string
    fieldNamePrefix: string
    formik: FieldKit<FormikValues>
    label?: string
    prefilled?: boolean
    hullCaptive?: string
}

export default function MakeDropdown(props: Readonly<MarineMakeDropdownProps>) {
    const { condition, assetSubtype, prefilled, hullCaptive, ...rest } = props

    const dataSource =
        condition === 'N' ? ['LOS_ADMIN', 'LOS'] : ['LOS_ADMIN', 'NADA']

    return (
        <BaseMakeDropdown
            {...rest}
            assetSubType={assetSubtype}
            dataSource={dataSource}
            assetType={AssetType.MARINE}
            prefilled={prefilled}
            searchable
            searchPlaceholder="Search makes..."
            captive={
                assetSubtype === AssetSubtype.MARINE_HULL
                    ? hullCaptive
                    : undefined
            }
        />
    )
}
